import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {finalize, takeUntil} from 'rxjs/operators';
import {
  IUserContact,
  UserContactStatusEnum,
  UserContactTypeEnum,
} from '../../../../@core/interfaces/user/user-contact.interface';
import {UserService} from '../../../../@shared/services/user.service';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
})
export class ContactsComponent implements OnInit, OnDestroy {
  public readonly displayedColumns: string[] = [
    'type',
    'address',
    'status',
    'verifiedAt',
    'createdAt',
    'revokedAt',
    'copy',
  ];

  public contacts: IUserContact[] = [];
  public includeRevoked: boolean = false;
  public isLoading: boolean = false;
  public hasError: boolean = false;

  private readonly destroyed$: Subject<void> = new Subject<void>();

  constructor(private readonly userService: UserService) {}

  public ngOnInit(): void {
    this.loadContacts();
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public reload(): void {
    this.loadContacts();
  }

  public getTypeLabel(type: UserContactTypeEnum): string {
    return type === UserContactTypeEnum.EMAIL ? 'Email' : 'Телефон';
  }

  public getStatusLabel(status: UserContactStatusEnum): string {
    switch (status) {
      case UserContactStatusEnum.VERIFIED:
        return 'Подтверждён';
      case UserContactStatusEnum.REVOKED:
        return 'Отозван';
      default:
        return 'Ожидает подтверждения';
    }
  }

  private loadContacts(): void {
    this.isLoading = true;
    this.hasError = false;

    this.userService.getUserContacts(this.includeRevoked)
      .pipe(
        finalize(() => this.isLoading = false),
        takeUntil(this.destroyed$),
      )
      .subscribe(
        contacts => this.contacts = contacts,
        () => {
          this.contacts = [];
          this.hasError = true;
        },
      );
  }
}
